import { useState } from "react";
const AttributeTableRows = ({ rowsData, deleteTableRows, handleChange }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    deleteTableRows(deleteIndex);
    setShowDeleteModal(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  return rowsData.map((data, index) => {
    const { ID, Name, CostPrice, SellingPrice } = data;
    return (
      <tr key={index}>
        <td>
          <input type="hidden" name="ID" value={ID} />
          <input
            type="text"
            className="form-control form-control-sm"
            name="Name"
            value={Name}
            onChange={(evnt) => handleChange(index, evnt)}
          />
        </td>
        <td>
          <input
            type="number"
            className="form-control form-control-sm"
            name="CostPrice"
            // value={Number(CostPrice).toFixed(2)}
            value={CostPrice}
            onChange={(evnt) => handleChange(index, evnt)}
          />
          {/* {!CostPriceValidation ? (
                            <div style={{ color: "red" }}>Please Enter Number Value</div>
                        ): false} */}
        </td>
        <td>
          <input
            type="number"
            className="form-control form-control-sm"
            name="SellingPrice"
            //value={Number(SellingPrice).toFixed(2)}
            value={SellingPrice}
            onChange={(evnt) => {
              handleChange(index, evnt);
            }}
          />
          {/* {!SellingPriceValidation ? (
                            <div style={{ color: "red" }}>Please Enter Number Value</div>
                        ) : false} */}
        </td>

        <td>
          <i
            className="fa fa-trash text-red fa-2x"
            data-bs-toggle="tooltip"
            title="Delete"
            onClick={() => handleDeleteClick(index)}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          />
          {/* Delete confirmation modal */}
          <div
            className={`modal ${showDeleteModal ? "d-block" : ""}`}
            tabIndex="-1"
          >
            <div style={{width : " 400px"}} className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 style={{fontSize: "20px"}} className="modal-title">Confirmation</h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={handleClose}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-12">
                      <h6  style={{fontSize : "18px" , fontWeight:  "600"}} >Are you sure you want to delete this row?</h6>
                    </div>
                  </div>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={handleConfirmDelete}
                  >
                    Delete
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={handleCancelDelete}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  });
};

export default AttributeTableRows;
